import { useHistory } from "react-router";
import HeaderBar from "../../../components/header/headerBar";
import SelectFeild from "../../../components/select/selectField";
import Input from "../../../components/textfield/input";
import {
  Textarea,
  TextBox,
} from "../../../components/textfield";
import { useEffect, useState } from "react";
import IconMdi from "@mdi/react";
import NumberFormat from "react-number-format";
import {
  mdiDelete,
  mdiChevronDownCircleOutline,
  mdiChevronUpCircleOutline,
} from "@mdi/js";
import MainButton from "../../../components/button/mainButton";
import EmptyModel from "../../../components/modal/emptyModal";
import { SearchField } from "../../../components/textfield";
import "../../../assets/styles/admin/usergroup.scss";
import Button from "../../../components/button/Button";
import { numberWithCommas } from "../../../helpers/functions";
import {
  Table,
  Badge,
  Row,
  Col,
  DatePicker,
  Select,
  Space,
  Typography,
  Radio,
  Checkbox,
  InputNumber,
  Modal,
  Form,
  Spin,
  message,
} from "antd";
import { Icon } from "@iconify/react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import styled from 'styled-components'
interface ParamsType {
  id: string;
}
const PrCreate = () => {
  const { id } = useParams<ParamsType>();
  const { Option } = Select;
  const { Text } = Typography;
  const { confirm } = Modal;
  const history = useHistory();
  const [data, setData] = useState<any>({
    code: "",
    dateOder: "",
    dateReceive: "",
    oderList: [],
    orderBy: {}
  });
  const [isOpen1, setIsOpen1] = useState(false);
  const [productItem, setProductItem] = useState<any>([]);
  const [selectItem, setselectItem] = useState<any>({});
  const [unitList, setUnitList] = useState<any>([]);
  const [listTreatments, setlistTreatments] = useState<any>([]);

  const ChangRender = styled.div``
  const ReScalerCol = styled.div`
  padding-left: 2rem;
  }`
  const columns = [
    {
      key: "code",
      title: <>รหัส<br />Code</>,
      dataIndex: "code",
      align: "center" as "center",
      width: "100px",
    },
    {
      key: "name",
      title: <>ชื่อ<br />Name</>,
      dataIndex: "name",
      align: "center" as "center",
    },
    {
      key: "quantiyUnit",
      title: <>จำนวน/หน่วย<br />Quantity/Unit</>,
      dataIndex: "quantiyUnit",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return `${text} ${record?.unit?.name}`
      },

    },
    {
      key: "quantiySubUnit",
      title: <>หน่วยย่อย<br />Sub Unit</>,
      dataIndex: "quantiySubUnit",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return `${text} ${record?.subUnit?.name}`
      },
    },
    {
      key: "quantiySubUnit2",
      title: <>หน่วยย่อย2<br />Sub Unit 2</>,
      dataIndex: "quantiySubUnit2",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return `${text} ${record?.subUnit2?.name}`
      },
    },
    {
      key: "total_price_per_unit",
      title: <>ราคา/หน่วย<br />Price/Unit</>,
      dataIndex: "total_price_per_unit",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return numberWithCommas(record.total_price_per_unit, 2)
      },

    },

    {
      key: "total_price_per_unit",
      title: <>รวม<br />Total</>,
      dataIndex: "total_price_per_unit",
      align: "center" as "center",
      render: (text: any, record: any, index: any) => {
        return numberWithCommas(record.quantiyUnit * text, 2)
      },
    }
  ];

  useEffect(() => {
    getProduct();
    getData();
    getUnits()
  }, []);

  useEffect(() => {

  }, [listTreatments]);

  const addItem = () => {
    data.oderList.push(selectItem);
    setData(data);
    setselectItem({})
  }
  const removeItem = (index: number) => {
    let oderList = data.oderList;
    oderList.splice(index, 1);
    setData({
      ...data,
      oderList
    });
  }

  const getProduct = () => {
    axios.get(`/stock-products`).then((res) => {
      setProductItem(res?.data?.data)
    });
  };
  const getData = () => {
    axios.get(`/stock-products/po/${id}`).then((res) => {
      setData(res?.data)
    });
  };
  const getUnits = () => {
    axios.get(`/stock-product-units`).then((res) => {
      setUnitList(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          name: item?.name
        }
      }))
    });
  };
  const updatePo = () => {
    axios.patch(`/stock-products/po/${id}`, data).then((res) => {
      history.push('/setting/inventory/po')
    });
  }
  const updatePoDisapproved = () => {
    axios.patch(`/stock-products/po/${id}/disapproved`, data).then((res) => {
      history.push('/setting/inventory/po')
    });
  }
  const vat = data.oderList.reduce((total: number, item: any) => {
    return total + (item.total_price_per_unit * item.quantiyUnit)
  }, 0) * 7 / 107;
  const discount_vat = data.oderList.reduce((total: number, item: any) => {
    return total + (item.total_price_per_unit * item.quantiyUnit)
  }, 0) * 100 / 107;
  return (
    <>
      <HeaderBar title="PO Order" btnBack={true} />
      <div style={{ padding: "10px 40px" }}>
        <div className="create-page">
          <div className="title-header">
            <h3>อนุมัติใบขอซื้อ/Approve PR Order</h3>
          </div>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="เลขที่ใบขอซื้อ/PR No."
                className="p-0"
                value={data.code}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={16}>
              <ReScalerCol>
                <TextBox
                  title="ผู้ผลิต/Supplier"
                  className="p-0"
                  value={data?.supplier?.supplierName}
                />
              </ReScalerCol>
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="heading">
                <p>วันที่สั่งซื้อ/Date Order</p>
              </div>
              <Form.Item
                name="startDate"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <ChangRender>
                  <DatePicker
                    placeholder="mm/dd/yyyy"
                    format="DD-MM-YYYY"
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    defaultValue={moment(data?.dateOder)}
                    disabled
                  />
                </ChangRender>
              </Form.Item>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <div className="heading">
                <p>วันที่รับเข้า/Receive</p>
              </div>
              <Form.Item
                name="startDate"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <ChangRender>
                  <DatePicker
                    placeholder="mm/dd/yyyy"
                    format="DD-MM-YYYY"
                    style={{
                      height: "auto",
                      width: "100%",
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "2px solid #d9d9d9",
                    }}
                    defaultValue={moment(data?.dateReceive)}
                    disabled
                  />
                </ChangRender>
              </Form.Item>
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="สั่งโดย/Order by"
                className="p-0"
                value={data?.orderBy?.displayName}
              />
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="ภาษี/Vat"
                className="p-0"
                value={data?.vat}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>
              <TextBox
                title="ชำระเงิน/Credit"
                className="p-0"
                value={data?.credit?.name}
              />
            </Col>
            <Col xs={24} sm={4} md={8} lg={7}>

            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={24} md={24} lg={24}>
              <Textarea
                title="รายละเอียด/Details"
                placeholder=""
                value={data?.details}
                disabled
              />
            </Col>
          </Row>
        </div>

        <div className="create-page mt-4">
          <div className="title-header" style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center'
          }}>
            <h3>รายการสั่งซื้อ/Order List</h3>
          </div>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={24} md={24} lg={24}>
              <ChangRender>
                {
                  data.oderList &&
                  <Table
                    columns={columns}
                    dataSource={data.oderList}
                    bordered
                    scroll={{ x: "max-content" }}
                    rowKey="_id"
                  />
                }
              </ChangRender>
            </Col>
          </Row>
          <Row
            justify="space-between"
            style={{
              marginTop: "10px",
            }}
          >
            <Col xs={24} sm={12} md={12} lg={12}>

            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <Row className="mt-2">
                <Col xs={24} sm={16} md={16} lg={16} style={{
                  textAlign: 'right',
                  color: '#5baea9',
                  fontWeight: 'bold'
                }}>รวม/Total</Col>
                <Col xs={24} sm={8} md={8} lg={8} style={{
                  textAlign: 'right',
                  borderBottom: '1px solid #d3d8dd'
                }}>
                   {
                    data?.vat === "Include" ?
                    numberWithCommas(data.oderList.reduce((total: number, item: any) => {
                      return total + (item.total_price_per_unit * item.quantiyUnit)
                    }, 0))
                    :
                    numberWithCommas(data.oderList.reduce((total: number, item: any) => {
                      return total + (item.total_price_per_unit * item.quantiyUnit)
                    }, 0) + vat)
                  }
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={24} sm={16} md={16} lg={16} style={{
                  textAlign: 'right',
                  color: '#5baea9',
                  fontWeight: 'bold'
                }}>ภาษี/Vat</Col>
                <Col xs={24} sm={8} md={8} lg={8} style={{
                  textAlign: 'right',
                  borderBottom: '1px solid #d3d8dd'
                }}>
                  {numberWithCommas(vat, 2)}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col xs={24} sm={16} md={16} lg={16} style={{
                  textAlign: 'right',
                  color: '#5baea9',
                  fontWeight: 'bold'
                }}>ราคารวม/Total Price</Col>
                <Col xs={24} sm={8} md={8} lg={8} style={{
                  textAlign: 'right',
                  borderBottom: '1px solid #d3d8dd'
                }}>
                  {
                    numberWithCommas(data.oderList.reduce((total: number, item: any) => {
                      return total + (item.total_price_per_unit * item.quantiyUnit)
                    }, 0) + vat, 2)
                  }
                </Col>
              </Row>
            </Col>
          </Row>
          {
            data?.statusProcess === "Pending" &&
            <div className="justify-center mt-20">
              <MainButton className="mg-10" background="#4285F4" title="พิมพ์/Print" />
              <MainButton className="mg-10" background="#E76464" title="ไม่อนุมัติ/Disapproved" onClick={() => updatePoDisapproved()} />
              <MainButton
                className="mg-10"
                title="บันทึกและอนุมัติ/
              Save and Approve"
                onClick={() => {
                  updatePo()
                }}
              />
            </div>
          }
        </div>
      </div>
    </>
  );

};
export default PrCreate;
